import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { TitleCasePipe } from '@angular/common';

interface SortingByIndicators {
  name: string,
  icon: string,
  slug: string,
  active: boolean
}

@Component({
  selector: 'app-to-page-header',
  templateUrl: './to-page-header.component.html',
  styleUrls: ['./to-page-header.component.scss']
})

export class ToPageHeaderComponent implements OnInit {
  @Input() set setViewFilters(value: any) {
    if (value) {
      if (value.indicator === 'teamSuccessteamScore') {
        this.sortByCategory(0);
      } else {
        const indicatorIndex = this.sortingByIndicators.findIndex(indicator => indicator.slug === value.indicator.toLowerCase());
        this.sortByCategory(indicatorIndex);
      }
      this.sortByDays(value.days);
    } else {
      this.is30DaysSorting = true;
      this.sortingByIndicators[0].active = true;
    }
  }

  @Output() setDaysForSwitch = new EventEmitter<any>();
  @Output() setIndicatorForSort = new EventEmitter<any>();
  
  sortingByIndicators: SortingByIndicators[] = [
    {name: this.translate.instant('team_score'), icon: '',slug: 'score', active: false},
    {name: this.translate.instant('team_performance'), icon: 'performance',slug: 'performance', active: false},
    {name: this.translate.instant('team_satisfaction'), icon: 'satisfaction',slug: 'satisfaction', active: false},
    {name: this.translate.instant('team_motivation'), icon: 'motivation',slug: 'motivation', active: false},
    {name: this.translate.instant('team_stress_free'), icon: 'stress',slug: 'stress', active: false},
  ];

  is30DaysSorting: boolean = false;
  is90DaysSorting: boolean = false;

  titleCasePipe = new TitleCasePipe();

  constructor(private translate: TranslateService) { }

  ngOnInit(): void {
  }

  sortByDays(days: number) {
    if (days === 30) {
      this.is30DaysSorting = true;
      this.is90DaysSorting = false;
    } else {
      this.is90DaysSorting = true;
      this.is30DaysSorting = false;
    }
    this.setDaysForSwitch.emit(days);
  }

  sortByCategory(categoryIndex: number) {
    this.sortingByIndicators.forEach((indicator: any, index: number) => {
      if (categoryIndex === index) {
        indicator.active = true;
        if (indicator.slug === 'score') {
          this.setIndicatorForSort.emit('teamSuccessteamScore');
        } else {
          this.setIndicatorForSort.emit(this.titleCasePipe.transform(indicator.slug));
        }
      } else {
        indicator.active = false;
      }
    });
  }

}
